const styles = {
  paddingX: "sm:px-16 px-6",
  paddingY: "sm:py-16 py-6",
  padding: "sm:px-16 px-6 sm:py-16 py-10",

  // Hero display typography — tight, confident, typography-led.
  heroHeadText:
    "font-display font-medium text-white tracking-display leading-[1.05] lg:text-[64px] md:text-[52px] sm:text-[44px] text-[36px]",
  heroSubText:
    "text-secondary font-normal leading-[1.6] lg:text-[20px] sm:text-[18px] text-[16px]",

  // Section headers — one notch smaller than hero, same typographic language.
  sectionHeadText:
    "text-white font-display font-medium tracking-display leading-[1.1] md:text-[44px] sm:text-[36px] text-[28px] mt-1",
  sectionSubText:
    "section-num",
};

export { styles };
